"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparisonBarItem = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _useTooltip2 = require("b2b-components/hooks/useTooltip");
var _Icon = require("b2b-components/theme/components/Icon");
var _device = require("b2b-components/utils/device");
var _classnames = _interopRequireDefault(require("classnames"));
require("./ComparisonBarItem.scss");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var ComparisonBarItem = function ComparisonBarItem(_ref) {
  var item = _ref.item,
    _onClick = _ref.onClick,
    onRemove = _ref.onRemove,
    _ref$isListItem = _ref.isListItem,
    isListItem = _ref$isListItem === void 0 ? true : _ref$isListItem,
    className = _ref.className,
    tooltipClassName = _ref.tooltipClassName,
    deviceType = _ref.deviceType;
  var Element = isListItem ? 'li' : 'div';
  var _useTooltip = (0, _useTooltip2.useTooltip)({
      isPositionFixed: true
    }),
    tooltipAnchorRef = _useTooltip.tooltipAnchorRef,
    tooltipRef = _useTooltip.tooltipRef,
    tooltipPosition = _useTooltip.tooltipPosition,
    isTooltipVisible = _useTooltip.isTooltipVisible,
    onMouseEnter = _useTooltip.onMouseEnter,
    onMouseLeave = _useTooltip.onMouseLeave;
  var handleImageLoadError = function handleImageLoadError(event) {
    event.currentTarget.style.fontSize = '0';
  };
  var Tooltip = function Tooltip() {
    return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
      style: _objectSpread(_objectSpread({}, tooltipPosition.top && {
        top: tooltipPosition.top
      }), tooltipPosition.left && {
        left: tooltipPosition.left
      }),
      className: (0, _classnames["default"])('cds-ComparisonBarItem-Tooltip', tooltipClassName),
      ref: tooltipRef
    }, item.name), document.body);
  };
  return /*#__PURE__*/_react["default"].createElement(Element, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    className: (0, _classnames["default"])('cds-ComparisonBarItem', {
      'cds-ComparisonBarItem--Highlighted': isTooltipVisible,
      'cds-ComparisonBarItem--Mobile': (0, _device.isMobile)(deviceType)
    }, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-ComparisonBarItem-Content",
    ref: tooltipAnchorRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-ComparisonBarItem-ImageBox",
    onClick: function onClick() {
      return _onClick(item.id);
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: item.thumbnail,
    alt: item.name,
    className: "cds-ComparisonBarItem-Image",
    onError: handleImageLoadError
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-ComparisonBarItem-Remove",
    onClick: function onClick() {
      return onRemove(item.id);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.Icon.config.name.alertError,
    size: _Icon.Icon.config.size.small,
    className: "cds-ComparisonBarItem-RemoveIcon"
  }))), isTooltipVisible && /*#__PURE__*/_react["default"].createElement(Tooltip, null));
};
exports.ComparisonBarItem = ComparisonBarItem;